import { createSelector } from "@reduxjs/toolkit";
import { SET_AUTH, SET_AUTHENTICATING, SET_PREMIUM_ACCOUNT } from "../actions/authActions";

export const isAuth = createSelector(
    state => state.authState,
    authState => authState.auth
);

export const isPremiumAccount = createSelector(
    state => state.authState,
    authState => authState.premiumAccount
);

export const isAuthenticating = createSelector(
    state => state.authState,
    authState => authState.authenticating
);

const INITIAL_STATE = {
    auth: false,
    premiumAccount: false,
    authenticating: false
};

export const authState = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_AUTH:
            return {...state, auth: action.payload};
        case SET_PREMIUM_ACCOUNT:
            return {...state, premiumAccount: action.payload};
        case SET_AUTHENTICATING:
            return {...state, authenticating: action.payload};
        default:
            return state;
    }
}